import { render, staticRenderFns } from "./AutoFinetuneContactGroupField.vue?vue&type=template&id=06a8b039&scoped=true&"
import script from "./AutoFinetuneContactGroupField.vue?vue&type=script&lang=js&"
export * from "./AutoFinetuneContactGroupField.vue?vue&type=script&lang=js&"
import style0 from "./AutoFinetuneContactGroupField.vue?vue&type=style&index=0&id=06a8b039&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8b039",
  null
  
)

export default component.exports